export enum ConnectionStatusEnum {
  OK = 'ok',
  NOT_OK = 'not_ok',
  LOCKED = 'locked'
}
